module.exports = __webpack_public_path__ + "img/700f.29563eb1.png";